/**
 * aws-exports.js — VitalCare SOC Tracker
 * Cognito User Pool: us-west-2_5GZ1TlHwN
 */
const awsExports = {
  aws_project_region:           process.env.REACT_APP_AWS_REGION        || "us-west-2",
  aws_cognito_region:           process.env.REACT_APP_AWS_REGION        || "us-west-2",
  aws_user_pools_id:            process.env.REACT_APP_COGNITO_USER_POOL_ID  || "us-west-2_5GZ1TlHwN",
  aws_user_pools_web_client_id: process.env.REACT_APP_COGNITO_CLIENT_ID || "73jdietjt5dkqmdoc160ufn4ge",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL", "NAME"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 10,
    passwordPolicyCharacters: ["REQUIRES_LOWERCASE","REQUIRES_UPPERCASE","REQUIRES_NUMBERS","REQUIRES_SYMBOLS"],
  },
  aws_cloud_logic_custom: [
    {
      name:     "socTrackerApi",
      endpoint: process.env.REACT_APP_API_ENDPOINT || "https://13fk21ux3h.execute-api.us-west-2.amazonaws.com/default/vitalcare-soc-tracker-prod",
      region:   process.env.REACT_APP_AWS_REGION   || "us-west-2",
    },
  ],
};
export default awsExports;
